import { useEffect, useState } from 'react'

const useDebounce = (
  value: string | number | object | boolean | Array<object | string>,
  delay: number,
): string | number | object | boolean | Array<object | string> => {
  const [debouncedValue, setDebouncedValue] = useState(value)

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value)
    }, delay)

    return () => {
      clearTimeout(handler)
    }
  }, [value, delay])

  return debouncedValue
}

export default useDebounce
